// Capacitor platform detection — used to switch between Stripe (web) and
// RevenueCat (native iOS/Android) purchase flows.

export function isNativeApp() {
  if (typeof window === "undefined") return false;
  return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
}

export function getPlatform() {
  if (typeof window === "undefined") return "web";
  if (window.Capacitor && window.Capacitor.getPlatform) return window.Capacitor.getPlatform();
  return "web";
}

export function isIOSApp() {
  return getPlatform() === "ios";
}

export function isAndroidApp() {
  return getPlatform() === "android";
}
